import React, { createContext, useContext,useEffect,useState } from "react";

// Create a context for both MSAL instances
const MsalInstancesContext = createContext();

// Custom hook to access the context
export const useMsalInstances = () => useContext(MsalInstancesContext);

// Provider component
export const MsalInstancesProvider = ({ children, azureADInstance, b2cInstance }) => {
    const [isInitialized, setIsInitialized] = useState(false);

    useEffect(() => {
      const initializeInstances = async () => {
        try {
          await azureADInstance.initialize();
          await b2cInstance.initialize();
          setIsInitialized(true); // Set to true after both instances are initialized
        } catch (error) {
          console.error("Failed to initialize MSAL instances:", error);
        }
      };
  
      initializeInstances();
    }, [azureADInstance, b2cInstance]);
  
    if (!isInitialized) {
      return <div>Loading...</div>; // Show a loading state until initialization completes
    }
  
  return (
    <MsalInstancesContext.Provider value={{ azureADInstance, b2cInstance }}>
      {children}
    </MsalInstancesContext.Provider>
  );
};
